var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import Slides from '../slides';
import { Event } from '../../../base/base';
import { handleAd, rel, handleCallNewsApp, h5PageCount } from '../../../utils';
const dotTmpl = (current, total) => {
    return (React.createElement("div", { className: styles.dots_box },
        React.createElement("span", { className: styles.current }, current + 1),
        React.createElement("span", { className: styles.total }, `/${total}`)));
};
class ShareSlides extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            content: this.props.content,
        };
        this.event = new Event();
        // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
        this.insert = (insertArr, replaceArr, adFn) => {
            if (adFn && typeof adFn === 'function') {
                const { content } = this.props;
                const infoData = [...content];
                const refs = [];
                // 广告插入，在指定位置后插入广告位数据
                insertArr.forEach(item => {
                    if (item === 0 || item === infoData.length - 1) {
                        const ref = React.createRef();
                        const ref1 = React.createRef();
                        refs.push({ index: item, ref, ref1 });
                        infoData.splice(item, 0, { type: 'ad', ref, ref1 });
                    }
                    else {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 0, { type: 'ad', ref });
                    }
                });
                // 广告替换，在指定位置删除原数据，替换为广告位数据
                replaceArr.forEach(item => {
                    if (item === 0 || item === infoData.length - 1) {
                        const ref = React.createRef();
                        const ref1 = React.createRef();
                        refs.push({ index: item, ref, ref1 });
                        infoData.splice(item, 1, { type: 'ad', ref, ref1 });
                    }
                    else {
                        const ref = React.createRef();
                        refs.push({ index: item, ref });
                        infoData.splice(item, 1, { type: 'ad', ref });
                    }
                });
                // 广告数据整合处理完毕后，更新列表数据
                this.setState({
                    content: infoData,
                }, () => {
                    const dom = {};
                    for (const ref of refs) {
                        if (ref.ref && ref.ref.current && ref.ref1 && ref.ref1.current) {
                            dom[ref.index] = [ref.ref.current, ref.ref1.current];
                        }
                        else if (ref.ref && ref.ref.current) {
                            dom[ref.index] = ref.ref.current;
                        }
                    }
                    try {
                        adFn(dom);
                    }
                    catch (e) {
                        console.error(e);
                        this.setState({
                            content,
                        });
                    }
                });
            }
            return;
        };
        this.callupHandle = (slideItem) => {
            const nodata = '';
            const doc_type = slideItem.newstype;
            const aid = slideItem.id;
            const clickCountConfig = slideItem.clickCountConfig || '';
            const kind = slideItem.kind || '';
            const to_url = slideItem.to_url || '';
            const downloads = slideItem.downloads || {};
            if (slideItem.callUp === 1) {
                handleCallNewsApp(nodata, doc_type, aid, to_url, '', '', kind, {}, downloads);
            }
            if (clickCountConfig) {
                h5PageCount([clickCountConfig]);
            }
        };
        this.sliderTmpl = (item, isClone) => {
            const { newPage } = this.props;
            const props = newPage
                ? {
                    target: '_blank',
                    rel,
                }
                : {};
            const style = {
                width: window.innerWidth,
                height: window.innerWidth / 2,
            };
            return item.type === 'ad' ? (React.createElement("div", { className: styles.swiper, ref: isClone ? item.ref1 : item.ref })) : (React.createElement("div", { className: styles.swiper, style: style, onClick: this.callupHandle.bind(this, item) },
                React.createElement("a", Object.assign({ href: item.url }, props),
                    React.createElement("img", { src: item.src, width: window.innerWidth, height: window.innerWidth / 2 })),
                React.createElement("div", { className: styles.swiper_txt },
                    React.createElement("div", { className: styles.txt },
                        React.createElement("a", Object.assign({ href: item.url }, props), item.title)))));
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { ad } = this.props;
            if (ad) {
                try {
                    const callback = yield handleAd(ad);
                    callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
                }
                catch (e) {
                    console.error(e);
                }
                try {
                    this.event.trigger('init'); // 触发广告位插入方法
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }
    render() {
        const { content } = this.state;
        const { config } = this.props;
        let selfconfig = {
            sliderTmpl: this.sliderTmpl,
            dotTmpl,
            reboundWidth: 100,
            autoplay: content.length > 1,
        };
        if (config) {
            selfconfig = Object.assign(selfconfig, config);
        }
        return (React.createElement("div", { className: styles.box },
            React.createElement(Slides, { content: content, config: selfconfig })));
    }
}
export default ShareSlides;
